import * as types from '../constants/actionTypes';

export const fetchApprovalConfigRequest = () => ({
  type: types.FETCH_APPROVAL_CONFIG_REQUEST,
});
export const fetchApprovalConfigSuccess = (data) => ({
  type: types.FETCH_APPROVAL_CONFIG_SUCCESS,
  payload: data,
});
export const fetchApprovalConfigFailure = (error) => ({
  type: types.FETCH_APPROVAL_CONFIG_FAILURE,
  payload: error,
});

export const updateApprovalConfigRequest = (data) => ({
  type: types.UPDATE_APPROVAL_CONFIG_REQUEST,
  payload: data,
});
export const updateApprovalConfigSuccess = (data) => ({
  type: types.UPDATE_APPROVAL_CONFIG_SUCCESS,
  payload: data,
});
export const updateApprovalConfigFailure = (error) => ({
  type: types.UPDATE_APPROVAL_CONFIG_FAILURE,
  payload: error,
});

export const fetchPendingApprovalsRequest = () => ({
  type: types.FETCH_PENDING_APPROVALS_REQUEST,
});
export const fetchPendingApprovalsSuccess = (data) => ({
  type: types.FETCH_PENDING_APPROVALS_SUCCESS,
  payload: data,
});
export const fetchPendingApprovalsFailure = (error) => ({
  type: types.FETCH_PENDING_APPROVALS_FAILURE,
  payload: error,
});

export const fetchPOApprovalStatusRequest = (poId) => ({
  type: types.FETCH_PO_APPROVAL_STATUS_REQUEST,
  payload: poId,
});
export const fetchPOApprovalStatusSuccess = (poId, data) => ({
  type: types.FETCH_PO_APPROVAL_STATUS_SUCCESS,
  payload: { poId, data },
});
export const fetchPOApprovalStatusFailure = (error) => ({
  type: types.FETCH_PO_APPROVAL_STATUS_FAILURE,
  payload: error,
});

export const approvePORequest = (poId, data) => ({
  type: types.APPROVE_PO_REQUEST,
  payload: { poId, data },
});
export const approvePOSuccess = (data) => ({
  type: types.APPROVE_PO_SUCCESS,
  payload: data,
});
export const approvePOFailure = (error) => ({
  type: types.APPROVE_PO_FAILURE,
  payload: error,
});

export const rejectPOApprovalRequest = (poId, data) => ({
  type: types.REJECT_PO_APPROVAL_REQUEST,
  payload: { poId, data },
});
export const rejectPOApprovalSuccess = (data) => ({
  type: types.REJECT_PO_APPROVAL_SUCCESS,
  payload: data,
});
export const rejectPOApprovalFailure = (error) => ({
  type: types.REJECT_PO_APPROVAL_FAILURE,
  payload: error,
});

export const clearApprovalError = () => ({
  type: types.CLEAR_APPROVAL_ERROR,
});
